// extracted by mini-css-extract-plugin
export default {"modal":"WUh5EWuH","key":"Ql2_3M5o"};